import { createContext, useState, useContext, useMemo } from "react";

const ViewPresentationContext = createContext();

export const useViewContext = () => useContext(ViewPresentationContext);

export const ViewContextProvider = ({ children }) => {
  const [slideAudioData, setSlideAudioData] = useState(null);
  const [showAudioPrompt, setShowAudioPrompt] = useState(true);

  const value = useMemo(
    () => ({
      slideAudioData, setSlideAudioData,
      showAudioPrompt, setShowAudioPrompt,
    }),
    [slideAudioData, showAudioPrompt],
  );

  return (
    <ViewPresentationContext.Provider value={value}>
      {children}
    </ViewPresentationContext.Provider>
  )
}